// extracted by mini-css-extract-plugin
export default {"container":"LargeNetworkCard_container__2yKTb","wrapper":"LargeNetworkCard_wrapper__MoXFD","location":"LargeNetworkCard_location__wqlqa"};